import type { DamageCostReason } from '@app/hooks/useDamageCost'
import { roundForDisplay } from '@app/components/Molecules/Charts/utils/utils'

const REASON_MESSAGES: Record<DamageCostReason, string> = {
  no_damage_ratio_data:
    'Unable to calculate damage cost - damage ratios are not available for this asset element.',
  missing_replacement_cost:
    'Unable to calculate damage cost - replacement cost is unavailable for this element.',
}

export const reasonMessage = (reason?: DamageCostReason): string =>
  reason
    ? REASON_MESSAGES[reason]
    : 'Min and Max cost estimates derived from underlying damage curve variability.'

/**
 * Format an [damage_cost_min, damage_cost_max] band as a currency-prefixed range string. The
 * larger bound drives unit selection (k/M/B) so both ends share a common
 * scale: e.g. "$1.2M – $2.4M".
 */
export const formatDamageCostBand = (
  damage_cost_min: number,
  damage_cost_max: number,
  currencySymbol: string,
): string => {
  const maxAbs = Math.max(Math.abs(damage_cost_min), Math.abs(damage_cost_max))
  const minStr = roundForDisplay(damage_cost_min, '$', maxAbs)
  const maxStr = roundForDisplay(damage_cost_max, '$', maxAbs)
  if (minStr === maxStr) {
    return `${currencySymbol}${maxStr}`
  }
  return `${currencySymbol}${minStr} – ${currencySymbol}${maxStr}`
}
